import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { FormWithRedirect, NumberInput, SelectInput, Toolbar } from "react-admin";
import { CustomDatetime } from "../../../Components/CustomDatetime";
import CreatedByInput from "../../../Components/ReferenceFields/CreatedBy/CreatedByInput";
import UpdatedByInput from "../../../Components/ReferenceFields/UpdatedBy/UpdatedByInput";
import { PeriodMonths } from "../../../Constants/Constant";
import * as YearList from "../../../Constants/YearList";
import { SourceAircraftUtilization } from "../Constant/Source";
import { useAuth } from "@airborne/react-admin";

const AircraftUtilizationEditForm = props => {
  const { user } = useAuth();
  return (
    <FormWithRedirect
      {...props}
      warnWhenUnsavedChanges={true}
      render={(formProps: any) => (
        <Card>
          <form>
            <CardContent>
              <Box display={{ md: "block", lg: "flex" }}>
                <Box flex={2}>
                  <Grid container direction="row" alignItems="flex-start">
                    <Typography variant="h6" gutterBottom color="primary">
                      Creation Information
                    </Typography>
                  </Grid>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CreatedByInput fullWidth disabled />
                    </Box>
                    <Box flex={1} ml={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="createdDate" label="CREATED DATE" fullWidth showTime disabled />
                    </Box>
                  </Box>
                  <Box mt="1em" />
                  <Grid container direction="row" alignItems="flex-start">
                    <Typography variant="h6" gutterBottom color="primary">
                      Update Information
                    </Typography>
                  </Grid>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <UpdatedByInput fullWidth disabled label="MODIFIED BY" />
                    </Box>
                    <Box flex={1} ml={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="updatedDate" label="MODIFIED DATE" fullWidth showTime disabled />
                    </Box>
                  </Box>
                  <Box mt="1em" />

                  <Typography variant="h6" gutterBottom color="primary">
                    Updatable Field
                  </Typography>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <SelectInput
                        source="periodYear"
                        choices={YearList.default}
                        optionText="key"
                        optionValue="key"
                        fullWidth
                      ></SelectInput>
                    </Box>

                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <SelectInput
                        source="periodMonth"
                        choices={PeriodMonths}
                        optionText="month"
                        optionValue="value"
                        fullWidth
                      ></SelectInput>
                    </Box>
                  </Box>

                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <NumberInput source="flightCycle" label="FLIGHT CYCLE" fullWidth />
                    </Box>

                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <NumberInput source="flightHour" label="FLIGHT HOUR" fullWidth />
                    </Box>

                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <NumberInput source="flightMinute" label="FLIGHT MINUTE" fullWidth />
                    </Box>
                  </Box>

                  {user?.isCustomer === false && (
                    <>
                      <Box mt="1em" />
                      <Typography variant="h6" gutterBottom color="primary">
                        Flight Radar Information
                      </Typography>
                      <Box display={{ xs: "block", sm: "flex" }}>
                        <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                          <Typography variant="caption" color="textSecondary">
                            FR CYCLE
                          </Typography>
                          <Typography variant="body1">
                            {formProps.record?.frCycle != null ? formProps.record.frCycle : "—"}
                          </Typography>
                        </Box>
                        <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                          <Typography variant="caption" color="textSecondary">
                            FR HOUR
                          </Typography>
                          <Typography variant="body1">
                            {formProps.record?.frHour != null ? formProps.record.frHour : "—"}
                          </Typography>
                        </Box>
                        <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                          <Typography variant="caption" color="textSecondary">
                            FR MINUTE
                          </Typography>
                          <Typography variant="body1">
                            {formProps.record?.frMinute != null ? formProps.record.frMinute : "—"}
                          </Typography>
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            </CardContent>
            <Toolbar
              {...props}
              placeholder=""
              record={formProps.record}
              basePath={formProps.basePath}
              undoable={true}
              invalid={formProps.invalid}
              handleSubmit={formProps.handleSubmit}
              saving={formProps.saving}
              resource={SourceAircraftUtilization}
            />
          </form>
        </Card>
      )}
    />
  );
};

export default AircraftUtilizationEditForm;
